export const ASSIGNMENT_SERVICES = {
    requirement: 'requirement',
    assignment: 'assignment',
};
